import { ICommand } from './ICommand';

export class Response{
    view:string;
    command:ICommand;
    
    constructor (view:string, command:ICommand) 
    {
        this.view = view;
        this.command = command;
    }
    
    getView():string {
        return this.view;
    }
    getCommand():ICommand {
        return this.command;
    }
}